const JsCalendar = {
	init () {

		/*
		* Jquery Datepicker (Calendar)
		*/

		// Jquery UI Datepicker, used with low events and segments
    // Month Units
		// if ( $('.em-datepicker').length ) {

  //     if ( $('.em-datepicker').hasClass('filtered-datepicker') ) {

  //       let targetStartDate = $('.datepicker-start-date').text();

  //       $('.em-datepicker').datepicker({
  //         defaultDate: new Date(targetStartDate),
  //         // changeMonth: true,
  //         // changeYear: true,
  //         minDate: '-100Y',
  //         maxDate: '0',
  //         yearRange: '-100:+0',
  //         dateFormat: 'yy-mm'
  //       }).click(function(e) {
  //         e.stopPropagation();
  //       });

  //       $('.em-datepicker').on("change",function(){
  //         var selectedDate = $(this).val();

  //         let targetUrl = window.location.href;

  //         targetUrl = targetUrl.substring(0, targetUrl.length - 7);

  //         targetUrl = targetUrl + selectedDate;

  //         window.location.assign(targetUrl);
  //       });

  //     } else {
  //       $('.em-datepicker').datepicker({
  //         // changeMonth: true,
  //         // changeYear: true,
  //         minDate: '-100Y',
  //         maxDate: '0',
  //         yearRange: '-100:+0',
  //         dateFormat: 'yy-mm'
  //       }).click(function(e) {
  //         e.stopPropagation();
  //       });

  //       $('.em-datepicker').on("change",function(){
  //         var selectedDate = $(this).val();

  //         let targetUrl = window.location.href + '/filtered/' + selectedDate;

  //         window.location.assign(targetUrl);
  //       });
  //     }
		// }

    // Week Units
    if ( $('.em-datepicker').length ) {

      function availableDates(date) {
        var day = date.getDate(),
        last=(new Date(date.getFullYear(),date.getMonth() + 1, 0, 23, 59, 59)).getDate();
        if (day==1) {
          return [true, "", "Available"];
        } else {
          return [false, "", "unAvailable"];
        }
      }

      // $('.em-datepicker').find('table').find('tbody').find('tr').find('td')

      if ( $('.em-datepicker').hasClass('filtered-datepicker') ) {

        let targetStartDate = $('.datepicker-start-date').text();

        $('.em-datepicker').datepicker({
          defaultDate: new Date(targetStartDate),
          changeMonth: true,
          changeYear: true,
          minDate: '-100Y',
          maxDate: '0',
          yearRange: '-100:+0',
          beforeShowDay: availableDates,
          dateFormat: 'yy-mm'
          // dateFormat: 'yy-mm-dd'
        }).click(function(e) {
          e.stopPropagation();
        });

        $('.em-datepicker').on("change",function(){
          var selectedDate = $(this).val();

          let targetUrl = window.location.href;

          targetUrl = targetUrl.substring(0, targetUrl.length - 7);

          targetUrl = targetUrl + selectedDate;

          window.location.assign(targetUrl);
        });

      } else {
        $('.em-datepicker').datepicker({
          changeMonth: true,
          changeYear: true,
          minDate: '-100Y',
          maxDate: '0',
          yearRange: '-100:+0',
          beforeShowDay: availableDates,
          dateFormat: 'yy-mm'
          // dateFormat: 'yy-mm-dd'
        }).click(function(e) {
          e.stopPropagation();
        });

        $('.em-datepicker').on("change",function(){
          var selectedDate = $(this).val();

          let targetUrl = window.location.href + '/filtered/' + selectedDate;

          window.location.assign(targetUrl);
        });
      }
    }

		// if ( $('.em-datepicker-range').length ) {

		// 	$('.em-datepicker-range').datepicker({
		// 		changeMonth: true,
		// 		changeYear: true,
		// 		minDate: '-20Y',
		// 		maxDate: '0',
		// 		defaultDate: '-1Y',
		// 		yearRange: '-20:+0',
		// 		numberOfMonths: 1,
		// 		dateFormat: 'yy-mm-dd'
		// 	});
		// }
	}
};

export default JsCalendar;



// WEBPACK FOOTER //
// ./src/components/01-elements/calendar/calendar.js